
<header
  class="sticky top-0 z-50 bg-gray-100 shadow-md border-b border-gray-200 px-3 py-2 lg:px-6 lg:py-4 flex items-center justify-between h-12 lg:h-16"
  (click)="onHeaderClick($event)"
>
  <!-- Logo, Operator Logo, and App Instance -->
  <div class="flex items-center gap-4 h-full">
    <!-- Fusion Logo -->
    <img
      src="Main_logo.png"
      [attr.alt]="'Logo' | transloco"
      class="w-24 h-6 lg:w-32 lg:h-8 cursor-pointer"
      (click)="navigateTo('/platform/home')"
    />
    <div class="flex flex-row lg:pl-16 h-full items-center">
    
    <!-- Operator logo -->
    <div
      *ngIf="getAppName() && getOperatorLogo() && !isOperatorLogoLoadFailed"
      class="hidden lg:flex items-center justify-center w-auto h-12 overflow-hidden ml-4"
    >
      <img
        [src]="getOperatorLogoDataUri()"
        [alt]="getOperatorName() + ' logo'"
        class="max-w-full max-h-full object-contain"
        (error)="onOperatorLogoError()"
      />
    </div>
    
    <!-- App Instance Name -->
    <div *ngIf="getAppName()" class="flex flex-col items-start ml-0 lg:ml-4 min-w-0">
      <span class="text-sm lg:text-lg font-semibold text-blue-800 truncate max-w-[120px] sm:max-w-[200px] lg:max-w-none">{{ getAppName() }}</span>
      <span class="text-sm lg:text-lg font-normal text-blue-800 truncate max-w-[120px] sm:max-w-[200px] lg:max-w-none">{{ getOperatorName() }}</span>
    </div>
    </div>
  </div>

  <!-- Search Bar - Hidden for now (not implemented) -->
  <!-- <div *ngIf="isSuperUser" class="flex-grow max-w-md mx-8 hidden lg:block">
    <div class="relative">
      <input
        type="text"
        [attr.placeholder]="'Search' | transloco"
        [disabled]="modalState.isModalOpen()"
        [ngClass]="modalState.isModalOpen() ? 'opacity-50 cursor-not-allowed' : ''"
        class="w-full rounded-full pl-4 pr-10 py-2 border border-gray-300 focus:outline-none focus:ring focus:ring-blue-200"
        style="box-shadow: inset 0 2px 6px rgba(0, 0, 0, 0.342)"
      />
      <div
        class="absolute right-3 top-1/2 transform -translate-y-1/2 text-blue-500"
        [ngClass]="modalState.isModalOpen() ? 'opacity-50' : ''"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-5 w-5"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M21 21l-4.35-4.35m1.36-5.65a7 7 0 11-14 0 7 7 0 0114 0z"
          />
        </svg>
      </div>
    </div>
  </div> -->

  <!-- Desktop Icons (hidden on small and medium screens) -->
  <div class="hidden lg:flex lg:items-center lg:space-x-4">
    <!-- Notification Bell Button -->
    <div class="relative group" *ngIf="isStationApp() && isAdmin() && canProcessConsumerApplications">
      <button
        [disabled]="modalState.isModalOpen()"
        attr.aria-label="{{'Notifications' | transloco}}"
        [ngClass]="modalState.isModalOpen() ? 'opacity-50 cursor-not-allowed' : 'hover:text-blue-600 hover:bg-blue-50'"
        class="w-10 h-10 rounded-full bg-white border border-blue-500 flex items-center justify-center text-blue-500 transition"
        data-menu-trigger="notification"
        (click)="toggleNotificationPanel()"
      >
        <!-- Bell SVG -->
        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
        </svg>
        <!-- Unread badge -->
        <span *ngIf="unreadCount > 0 && !notificationsLoading"
          class="absolute -top-1 -right-1 w-4 h-4 bg-red-500 text-white text-[10px] font-bold rounded-full flex items-center justify-center pointer-events-none">
          {{ unreadCount > 9 ? '9+' : unreadCount }}
        </span>
      </button>
      <!-- Tooltip (hidden when panel is open) -->
      <div *ngIf="!isNotificationPanelOpen" class="absolute top-full left-1/2 -translate-x-1/2 mt-1 px-2.5 py-1.5 bg-gray-800 text-white text-xs font-light rounded shadow-lg opacity-0 pointer-events-none group-hover:opacity-100 transition-opacity duration-200 whitespace-nowrap z-50">
        {{ 'Notifications' | transloco }}
      </div>
      <!-- Notification Panel -->
      <div
        *ngIf="isNotificationPanelOpen"
        class="absolute right-0 -mt-1 w-96 bg-white border border-gray-200 rounded-lg shadow-lg z-50"
        data-menu-panel="notification"
      >
        <div class="flex items-center justify-between px-4 py-3 border-b border-gray-100">
          <span class="text-sm font-semibold text-blue-600">{{ 'Notifications' | transloco }}</span>
          <span class="text-xs text-gray-400">{{ 'Last 30' | transloco }}</span>
        </div>
        <!-- Loading -->
        <!-- Error -->
        <!-- Empty -->
        <!-- List -->
        <app-notification-panel
          [logs]="notificationLogs"
          [loading]="notificationsLoading"
          [error]="notificationsError"
          [readIds]="readNotificationIds"
          class="block max-h-96 overflow-y-auto"
          (notificationClicked)="navigateToNotificationSource($event.source, $event.id)"
        ></app-notification-panel>
      </div>
    </div>

    <!-- Configuration Button -->
    <div class="relative group">
      <button
        *ngIf="isStationApp() && checkStationAppConfigurationPermissions()"
        attr.aria-label="{{'Configuration' | transloco}}"
        [disabled]="modalState.isModalOpen()"
        [ngClass]="modalState.isModalOpen() ? 'opacity-50 cursor-not-allowed' : 'hover:text-blue-600 hover:bg-blue-50'"
        class="w-10 h-10 rounded-full bg-white border border-blue-500 flex items-center justify-center text-blue-500 transition"
        (click)="showConfiguration()"
      >
        <!-- Settings SVG -->
        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
        </svg>
      </button>
      <div *ngIf="isStationApp() && checkStationAppConfigurationPermissions()" class="absolute top-full left-1/2 -translate-x-1/2 mt-1 px-2.5 py-1.5 bg-gray-800 text-white text-xs font-light rounded shadow-lg opacity-0 pointer-events-none group-hover:opacity-100 transition-opacity duration-200 whitespace-nowrap z-50">
        {{ 'Configuration' | transloco }}
      </div>
    </div>

    <!-- Help/Question Mark Button -->
    <div class="relative group">
      <button
        attr.aria-label="{{'Help Menu' | transloco}}"
        type="button"
        [disabled]="modalState.isModalOpen()"
        [ngClass]="modalState.isModalOpen() ? 'opacity-50 cursor-not-allowed' : 'hover:text-blue-600 hover:bg-blue-50'"
        class="w-10 h-10 rounded-full bg-white border border-blue-500 flex items-center justify-center text-blue-500 transition"
        id="help-menu-button"
        aria-expanded="false"
        data-menu-trigger="help"
        (click)="closeOtherDropdowns('help'); isHelpMenuOpen = !isHelpMenuOpen"
      >
        <!-- Question Mark SVG -->
        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5"
            d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01" />
        </svg>
      </button>
      <!-- Tooltip (hidden when dropdown is open) -->
      <div *ngIf="!isHelpMenuOpen" class="absolute top-full left-1/2 -translate-x-1/2 mt-1 px-2.5 py-1.5 bg-gray-800 text-white text-xs font-light rounded shadow-lg opacity-0 pointer-events-none group-hover:opacity-100 transition-opacity duration-200 whitespace-nowrap z-50">
        {{ 'Help & Support' | transloco }}
      </div>
      <!-- Desktop Help Dropdown -->
      <div
        *ngIf="isHelpMenuOpen"
        class="absolute right-0 -mt-1 w-48 bg-white border border-gray-200 rounded-lg shadow-lg z-50"
        data-menu-panel="help"
      >
        <!-- Download Manual - Shows appropriate PDF based on user role -->
        <button
          class="block w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-100"
          (click)="downloadManual(); isHelpMenuOpen = false "
        >
          {{ "Download Water+ Manual (PDF)" | transloco }}
        </button>
        <button
          class="block w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-100"
          (click)="contactUs(); isHelpMenuOpen = false"
        >
          {{ 'Contact Us' | transloco }}
        </button>
      </div>
    </div>

    <!-- Language Button -->
    <div class="relative group">
      <button
        [disabled]="modalState.isModalOpen()"
        [attr.aria-label]="activeLanguage.toUpperCase() + ' - ' + ('Select Language' | transloco)"
        type="button"
        [ngClass]="modalState.isModalOpen() ? 'opacity-50 cursor-not-allowed' : 'hover:text-blue-600 hover:bg-blue-50'"
        class="w-10 h-10 rounded-full bg-white border border-blue-500 flex items-center justify-center text-blue-700 disabled:text-blue-500 transition text-sm font-bold tracking-wide"
        data-menu-trigger="language"
        (click)="closeOtherDropdowns('language'); isLanguageMenuOpen = !isLanguageMenuOpen"
      >
        {{ activeLanguage.toUpperCase() }}
      </button>
      <!-- Tooltip (hidden when dropdown is open) -->
      <div *ngIf="!isLanguageMenuOpen" class="absolute top-full left-1/2 -translate-x-1/2 mt-1 px-2.5 py-1.5 bg-gray-800 text-white text-xs font-light rounded shadow-lg opacity-0 pointer-events-none group-hover:opacity-100 transition-opacity duration-200 whitespace-nowrap z-50">
        {{ 'Change Language' | transloco }}
      </div>
      <!-- Language Dropdown -->
      <div
        *ngIf="isLanguageMenuOpen"
        class="absolute right-0 -mt-1 w-40 bg-white border border-gray-200 rounded-lg shadow-lg z-50"
        data-menu-panel="language"
      >
        <button
          *ngFor="let lang of availableLanguages"
          class="flex items-center justify-between w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
          [class.font-semibold]="activeLanguage === lang.code"
          [class.text-blue-800]="activeLanguage === lang.code"
          (click)="setLanguage(lang.code)"
        >
          <span>{{ lang.label }}</span>
          <svg *ngIf="activeLanguage === lang.code" class="w-4 h-4 text-blue-800" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M5 13l4 4L19 7" />
          </svg>
        </button>
      </div>
    </div>

    <!-- User Icon Button -->
    <div class="relative group">
      <button
        attr.aria-label="{{'User Menu' | transloco}}"
        type="button"
        [disabled]="modalState.isModalOpen()"
        [ngClass]="modalState.isModalOpen() ? 'opacity-50 cursor-not-allowed' : 'hover:text-blue-600 hover:bg-blue-50'"
        class="w-10 h-10 rounded-full bg-white border border-blue-500 flex items-center justify-center text-blue-500 transition"
        id="user-menu-button"
        aria-expanded="false"
        data-menu-trigger="user"
        (click)="closeOtherDropdowns('user'); isUserMenuOpen = !isUserMenuOpen"
      >
        <!-- User SVG -->
        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M5.121 17.804A13.937 13.937 0 0112 15c2.21 0 4.29.533 6.121 1.476M15 10a3 3 0 11-6 0 3 3 0 016 0z" />
        </svg>
      </button>
      <!-- Tooltip (hidden when dropdown is open) -->
      <div *ngIf="!isUserMenuOpen" class="absolute top-full left-1/2 -translate-x-1/2 mt-1 px-2.5 py-1.5 bg-gray-800 text-white text-xs font-light rounded shadow-lg opacity-0 pointer-events-none group-hover:opacity-100 transition-opacity duration-200 whitespace-nowrap z-50">
        {{ 'My Account' | transloco }}
      </div>
      <!-- Desktop User Dropdown -->
      <div
        *ngIf="isUserMenuOpen"
        class="absolute right-0 -mt-1 w-48 bg-white border border-gray-200 rounded-lg shadow-lg z-50"
        data-menu-panel="user"
      >
        <button
          class="block w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-100"
          (click)="showProfileModal(); isUserMenuOpen = false"
        >
          {{ 'My Account' | transloco }}
        </button>
        <button
          class="block w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-100"
          (click)="logout(); isUserMenuOpen = false"
        >
          {{ "Sign Out" | transloco }}
        </button>
      </div>
    </div>
  </div>

  <!-- Hamburger Menu Button (visible on small and medium screens) -->
  <button class="lg:hidden flex items-center" (click)="toggleMobileMenu()" [attr.aria-label]="'Open menu' | transloco">
    <ng-container *ngIf="!isMobileMenuOpen; else closeIcon">
      <!-- Hamburger icon -->
      <svg class="h-5 w-5 lg:h-7 lg:w-7 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16"/>
      </svg>
    </ng-container>
    <ng-template #closeIcon>
      <!-- X (close) icon -->
      <svg class="h-5 w-5 lg:h-7 lg:w-7 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
      </svg>
    </ng-template>
  </button>
</header>

<!-- Mobile Menu Backdrop -->
<div
  *ngIf="isMobileMenuOpen"
  class="fixed left-0 right-0 bottom-0 top-[3.25rem] lg:top-[4.75rem] z-[59] bg-black bg-opacity-30"
  (click)="toggleMobileMenu()"
></div>

<!-- Mobile Menu (shown when hamburger is open) -->
<div
  *ngIf="isMobileMenuOpen"
  class="lg:hidden bg-white px-6 py-4 fixed left-0 right-0 top-[3rem] lg:top-[4.25rem] z-[60] max-h-[90vh] overflow-y-auto"
  style="min-width: 100vw;"
>
  <!-- Operator logo inside hamburger menu (mobile) -->
  <div
    *ngIf="getAppName() && getOperatorLogoDataUri()"
    class="mb-3 flex justify-center"
  >
    <img
      [src]="getOperatorLogoDataUri()"
      [alt]="getOperatorName() + ' logo'"
      class="h-10 w-auto object-contain"
      (error)="onOperatorLogoError()"
    />
  </div>

  <!-- MobileNav component first in hamburger menu -->
  <div class="flex justify-center items-center min-h-[48px]" *ngIf="isMobileNavLoading">
    <svg class="animate-spin h-6 w-6 text-blue-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
      <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"></path>
    </svg>
  </div>
  <app-mobilenav *ngIf="!isMobileNavLoading" (navigationClicked)="closeMobileMenu()"></app-mobilenav>

  <!-- Search Bar (optional on mobile, only visible for super users) -->
  <!-- <div *ngIf="isSuperUser" class="mb-4">
    <input
      type="text"
      [attr.placeholder]="'Search' | transloco"
      class="w-full rounded-full pl-4 pr-10 py-2 border border-gray-300 focus:outline-none focus:ring focus:ring-blue-200"
      style="box-shadow: inset 0 2px 6px rgba(0, 0, 0, 0.342)"
    />
  </div> -->
  <!-- Notification Bell Button (full width) -->
  <button
    *ngIf="isStationApp() && isAdmin()"
    [disabled]="modalState.isModalOpen()"
    attr.aria-label="{{'Notifications' | transloco}}"
    class="w-full flex items-center justify-start gap-2 rounded-lg bg-white border border-blue-500 text-blue-500 hover:text-blue-600 hover:bg-blue-50 transition px-4 py-2 mb-2"
    (click)="toggleNotificationPanel()"
  >
    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
        d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
    </svg>
    <span>{{ 'Notifications' | transloco }}</span>
    <span *ngIf="unreadCount > 0 && !notificationsLoading"
      class="ml-auto inline-flex items-center justify-center w-5 h-5 bg-red-500 text-white text-[10px] font-bold rounded-full">
      {{ unreadCount > 9 ? '9+' : unreadCount }}
    </span>
  </button>

  <!-- Mobile Notification Panel -->
  <div *ngIf="isStationApp() && isAdmin() && isNotificationPanelOpen" class="mb-2 rounded-lg border border-gray-200 bg-white shadow">
    <div class="flex items-center justify-between px-4 py-2 border-b border-gray-100">
      <span class="text-sm font-semibold text-blue-600">{{ 'Notifications' | transloco }}</span>
      <span class="text-xs text-gray-400">{{ 'Last 30' | transloco }}</span>
    </div>
    <app-notification-panel
      [logs]="notificationLogs"
      [loading]="notificationsLoading"
      [error]="notificationsError"
      [readIds]="readNotificationIds"
      class="block max-h-64 overflow-y-auto"
      (notificationClicked)="navigateToNotificationSource($event.source, $event.id)"
    ></app-notification-panel>
  </div>



  <!-- Configuration Button (full width) -->
  <button
    *ngIf="isStationApp() && checkStationAppConfigurationPermissions()"
    [attr.aria-label]="'Configuration' | transloco"
    class="w-full flex items-center justify-start gap-2 rounded-lg bg-white border border-blue-500 text-blue-500 hover:text-blue-600 hover:bg-blue-50 transition px-4 py-2 mb-2"
    (click)="showConfiguration()"
  >
    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
        d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
    </svg>
    <span>{{ 'Configuration' | transloco }}</span>
  </button>

  <!-- Help/Question Mark Button (full width) -->
  <button
    aria-label="('Help Menu' | transloco)"
    class="w-full flex items-center justify-between gap-2 rounded-lg bg-white border border-blue-500 text-blue-500 hover:text-blue-600 hover:bg-blue-50 transition px-4 py-2 mb-2"
    (click)="closeOtherDropdowns('help'); isHelpMenuOpen = !isHelpMenuOpen"
    type="button"
  >
    <span class="flex items-center gap-2">
      <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5"
          d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01" />
      </svg>
      <span>{{ 'Help' | transloco }}</span>
    </span>
    <svg [ngClass]="{'rotate-180': isHelpMenuOpen}" class="h-4 w-4 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/>
    </svg>
  </button>

  <!-- Help Dropdown (children) -->
  <div *ngIf="isHelpMenuOpen" class="pl-4">
    <!-- Download Manual - Shows appropriate PDF based on user role -->
    <button
      class="w-full flex items-center gap-2 rounded-lg bg-white border border-blue-300 text-blue-500 hover:text-blue-600 hover:bg-blue-50 transition px-4 py-2 mb-2"
      (click)="downloadManual(); isHelpMenuOpen = false"
    >
      <span>{{ "Download Water+ Manual (PDF)" | transloco }}</span>
    </button>
    <button
      class="w-full flex items-center gap-2 rounded-lg bg-white border border-blue-300 text-blue-500 hover:text-blue-600 hover:bg-blue-50 transition px-4 py-2 mb-2"
      (click)="contactUs(); isHelpMenuOpen = false"
    >
      <span>{{ 'Contact Us' | transloco }}</span>
    </button>
  </div>

  <!-- Language Button (full width) -->
  <button
    [attr.aria-label]="'Select Language' | transloco"
    class="w-full flex items-center justify-between gap-2 rounded-lg bg-white border border-blue-500 text-blue-500 hover:text-blue-600 hover:bg-blue-50 transition px-4 py-2 mb-2"
    (click)="closeOtherDropdowns('language'); isLanguageMenuOpen = !isLanguageMenuOpen"
    type="button"
  >
    <span class="flex items-center gap-2">
      <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5h12M9 3v2m1.048 9.5A18.022 18.022 0 016.412 9m6.088 9h7M11 21l5-10 5 10M12.751 5C11.783 10.77 8.07 15.61 3 18.129" />
      </svg>
      <span>{{ 'Language' | transloco }} &mdash; {{ activeLanguage.toUpperCase() }}</span>
    </span>
    <svg [ngClass]="{'rotate-180': isLanguageMenuOpen}" class="h-4 w-4 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/>
    </svg>
  </button>

  <!-- Language Dropdown (children) -->
  <div *ngIf="isLanguageMenuOpen" class="pl-4 mb-2">
    <button
      *ngFor="let lang of availableLanguages"
      class="w-full flex items-center justify-between gap-2 rounded-lg bg-white border border-blue-300 text-blue-500 hover:text-blue-600 hover:bg-blue-50 transition px-4 py-2 mb-2"
      [class.font-semibold]="activeLanguage === lang.code"
      (click)="setLanguage(lang.code)"
    >
      <span>{{ lang.label }}</span>
      <svg *ngIf="activeLanguage === lang.code" class="w-4 h-4 text-blue-800" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M5 13l4 4L19 7" />
      </svg>
    </button>
  </div>

  <!-- User Parent Button (toggles dropdown) -->
  <button
    class="w-full flex items-center justify-between gap-2 rounded-lg bg-white border border-blue-500 text-blue-500 hover:text-blue-600 hover:bg-blue-50 transition px-4 py-2 mb-2"
    (click)="closeOtherDropdowns('user'); isUserMenuOpen = !isUserMenuOpen"
    aria-label="('User Menu' | transloco)"
    type="button"
  >
    <span class="flex items-center gap-2">
      <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
          d="M5.121 17.804A13.937 13.937 0 0112 15c2.21 0 4.29.533 6.121 1.476M15 10a3 3 0 11-6 0 3 3 0 016 0z" />
      </svg>
      <span>{{ getUserName() }}</span>
    </span>
    <svg [ngClass]="{'rotate-180': isUserMenuOpen}" class="h-4 w-4 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/>
    </svg>
  </button>

  <!-- User Dropdown (children) -->
  <div *ngIf="isUserMenuOpen" class="pl-4">
    <button
      class="w-full flex items-center gap-2 rounded-lg bg-white border border-blue-300 text-blue-500 hover:text-blue-600 hover:bg-blue-50 transition px-4 py-2 mb-2"
      (click)="showProfileModal(); isUserMenuOpen = false"
    >
      <span>{{ 'Profile' | transloco }}</span>
    </button>
    <button
      class="w-full flex items-center gap-2 rounded-lg bg-white border border-blue-300 text-blue-500 hover:text-blue-600 hover:bg-blue-50 transition px-4 py-2 mb-2"
      (click)="logout()"
    >
      <span>{{ "Sign Out" | transloco }}</span>
    </button>
  </div>

</div>
<!-- Preload mobile nav in the background to improve render speed, hidden from view -->
<div style="display:none">
  <app-mobilenav></app-mobilenav>
</div>

<!-- Profile Modal -->
<app-profile
  *ngIf="showProfileModalToggle"
  [loading]="profileLoading"
  [onCancel]="closeProfileModal"
  [onSave]="handleProfileSave">
</app-profile>

<!-- Contact Us Modal -->
<app-contactus
  *ngIf="showContactUsModal"
  [onCancel]="closeContactUsModal">
</app-contactus>

<!-- Configuration Modal -->
<app-configuration
  *ngIf="showConfigModal"
  [configurationId]="configurationId"
  (close)="closeConfigModal()">
</app-configuration>
